import Plugin from '../Plugin'


export default class Chat extends Plugin {

    constructor(network) {
        super(network)
        this.events = {
            'send_message': this.sendMessage.bind(this),
            'send_safe': this.sendSafe.bind(this),
            'send_emote': this.sendEmote.bind(this),
            'send_joke': this.sendJoke.bind(this),
            'send_tour': this.sendTour.bind(this),
            'message_blocked': this.messageBlocked.bind(this)
        }
    }

    sendMessage(args) {
        if (this.world.room.isReady) {
            if (args.id === this.world.client.id && this.interface?.main) {
                this.interface.main.lastSentChat = ''
            }

            // Enhanced message display with Discord support
            const messageText = args.message
            const source = args.source || 'standard'
            
            // Add Discord indicator if message came from Discord
            if (source === 'discord' || source === 'hybrid') {
                this.interface.showTextBalloon(args.id, messageText, true, '💬')
            } else {
                this.interface.showTextBalloon(args.id, messageText)
            }
        }
    }

    sendSafe(args) {
        if (this.world.room.isReady) {
            const message = this.interface.main.safe.safeMessagesMap[args.safe]

            this.interface.showTextBalloon(args.id, message)
        }
    }

    sendEmote(args) {
        if (this.world.room.isReady) {
            // Support both single emote and multi-emote array
            const emote = args.emote || args.emotes
            
            console.log('[MultiEmote] Received emote data:', args, 'Resolved to:', emote)
            
            this.interface.showEmoteBalloon(args.id, emote)
        }
    }


    sendJoke(args) {
        if (this.world.room.isReady) {
            const message = this.crumbs.jokes[args.joke]

            this.interface.showTextBalloon(args.id, message, false)
        }
    }

    sendTour(args) {
        if (this.world.room.isReady) {
            this.interface.showTourMessage(args.id, args.roomId)
        }
    }

    messageBlocked(args = {}) {
        const detail = args.message || 'Your message was blocked by moderation.'

        if (this.interface?.prompt) {
            this.interface.prompt.showWindow(detail, 'single')
        }

        const original = args.originalMessage || this.interface?.main?.lastSentChat
        const chatInput = this.interface?.main?.chatInput
        if (original && chatInput) {
            chatInput.setText(original)
        }
    }

}
